import React from "react";
import AppLayout from "@/components/AppLayout";
import { useAuth } from "@/context/AuthContext";
import { isSupervisorOrAbove } from "@/lib/permissions";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ArrowsLeftRight, SignOut } from "@phosphor-icons/react";
import PendingTradesPanel from "@/components/PendingTradesPanel";
import PendingDropsPanel from "@/components/PendingDropsPanel";

/**
 * Trade & Drop Board
 * ------------------
 * Volunteers see ONLY the Trade Board — the Drop Board is a supervisor
 * review queue for shifts starting in less than 24 hours, and per spec
 * regular members shouldn't have visibility there.
 */
export default function TradeBoard() {
  const { user } = useAuth();
  const canSeeDrops = isSupervisorOrAbove(user);

  if (!canSeeDrops) {
    return (
      <AppLayout
        title="Trade Board"
        subtitle="Live trade requests across the corps — swap a tour or post an open trade"
      >
        <PendingTradesPanel />
      </AppLayout>
    );
  }

  return (
    <AppLayout
      title="Trade & Drop Board"
      subtitle="Trades org-wide · Drop review queue for shifts starting in under 24 hours"
    >
      <Tabs defaultValue="trades" className="w-full">
        <TabsList className="rounded-sm bg-slate-100 mb-4">
          <TabsTrigger value="trades" data-testid="tab-board-trades" className="rounded-sm">
            <ArrowsLeftRight size={12} weight="bold" className="mr-1" />Trade Board
          </TabsTrigger>
          <TabsTrigger value="drops" data-testid="tab-board-drops" className="rounded-sm">
            <SignOut size={12} weight="bold" className="mr-1" />Drop Board
          </TabsTrigger>
        </TabsList>
        <TabsContent value="trades"><PendingTradesPanel /></TabsContent>
        <TabsContent value="drops"><PendingDropsPanel /></TabsContent>
      </Tabs>
    </AppLayout>
  );
}
